import { FETCH_ALL_LEVELS } from '../../constants/actionTypes'

export default (vlnLevels = [], action) => {
    switch (action.type) {
        case FETCH_ALL_LEVELS:
            return action.payload;
        default:
            return vlnLevels;
    }
}